import React, { Component } from 'react';

import { spring, StaggeredMotion } from 'react-motion';

import ToolboxCard from 'components/Toolbox/ToolboxCard';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

export default class Toolbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toolbox: [],
    };
  }

  UNSAFE_componentWillMount() {
    DataHandler.matchAppId().then((appId) => {
      StorageHandler.load(storageKeys.lang).then((lang) => {
        if (lang) {
          const locale = `${lang.langFile.toLowerCase()}_${lang.langFile.replace('PT', 'BR').toUpperCase()}`;
          APIHandler.getToolbox(appId, '', `${locale}`).then((res) => {
            const startingValues = [];
            Object.keys(res).map(() => {
              const newObj = {};
              newObj.data = 0;
              newObj.pos = 20;
              return startingValues.push(newObj);
            });
            const toolboxItems = (
              <StaggeredMotion
                defaultStyles={startingValues}
                styles={(prevInterpolatedStyles) =>
                  prevInterpolatedStyles.map((_, i) =>
                    i === 0
                      ? {
                          data: spring(1, { stiffness: 320, damping: 28 }),
                          pos: spring(0, { stiffness: 320, damping: 28 }),
                        }
                      : {
                          data: spring(prevInterpolatedStyles[i - 1].data, { stiffness: 320, damping: 28 }),
                          pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }),
                        },
                )}
              >
                {(styles) => (
                  <React.Fragment>
                    {res.map((tool, id) => {
                      const { type, title, subtitle, url, itemID, image } = tool;

                      if (title.includes('HIDE_')) {
                        return null;
                      }

                      if (tool.type) {
                        const key = id;
                        return (
                          <div
                            key={key}
                            className="ToolboxCard__Animated"
                            style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}
                          >
                            <ToolboxCard
                              appId={appId}
                              image={image}
                              key={key}
                              index={key}
                              subtitle={subtitle}
                              title={title}
                              type={type}
                              url={url}
                              itemID={itemID.toString()}
                            />
                          </div>
                        );
                      }
                      return null;
                    })}
                  </React.Fragment>
                )}
              </StaggeredMotion>
            );
            this.setState({ toolbox: toolboxItems });
          });
        }
      });
    });
  }

  render() {
    const { toolbox } = this.state;
    return <div className="toolbox__Grid">{toolbox}</div>;
  }
}
